import LogoutButton from '~/themes/base/components/user/LogoutButton'

export default {
  extends: LogoutButton,
  methods: {
    async logout() {
      this.startLoading()
      await this.$store.dispatch('auth/LOGOUT')
    },
  },
}
